import * as React from "react";
type Props = {
  className?: string,
};
function SvgImproveHealth({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-ImproveHealth"
      className={className}
    >
      <path
        d="M35.5028 21.3049C35.2794 21.772 35.0255 22.239 34.7412 22.7164C34.599 22.7469 34.4467 22.7672 34.3045 22.7977C29.9989 23.7116 26.7494 27.4586 26.6276 31.9978C24.3529 34.0388 22.4541 35.4605 21.9361 35.6838C21.1543 36.0495 20.5044 36.3642 19.3365 35.6838C18.0978 35.1253 9.79124 29.0731 5.76995 21.3049C3.98278 17.8523 2.86576 14.3693 3.8914 11.0183C4.07416 10.4294 5.75987 6.52987 9.85212 5.3622C14.5842 4.00144 17.3666 6.82443 18.3516 8.06318C19.0421 8.94675 20.1591 10.805 20.6262 10.8964C21.0933 10.805 22.4846 9.04821 23.2156 8.23573C24.5764 6.74313 27.0033 4.60065 31.4307 5.3622C35.6246 6.08317 37.2087 10.4294 37.3916 11.0183C38.4172 14.3693 37.1579 17.7915 35.5028 21.3049Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
      />
      <path
        d="M40.4681 29.388L35.2314 36.5886L31.9584 33.9702M36.3249 22.5845C35.7867 22.5845 35.2587 22.6351 34.7408 22.7163C34.5986 22.7468 34.4464 22.7671 34.3042 22.7976C29.9986 23.7115 26.7492 27.4586 26.6273 31.9978C26.6172 32.0892 26.6172 32.1906 26.6172 32.282C26.6172 32.678 26.6373 33.0742 26.6881 33.4498C27.2669 38.2733 31.3593 41.9999 36.3249 41.9999C41.6866 41.9999 46.0328 37.6538 46.0328 32.282C46.0328 26.9307 41.6866 22.5845 36.3249 22.5845Z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgImproveHealth;
